import type { IconData } from '@stacksjs/iconify-core'

export const iCoffeeShop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M50.409 14.564q-.256 0-.51.011v-.009H14.628v23.245a6.296 6.296 0 0 0 6.295 6.296h22.679a6.3 6.3 0 0 0 6.296-6.296v-1.656q.252.012.509.013c6.199 0 11.224-4.665 11.224-10.862c.001-6.198-5.024-10.742-11.222-10.742m0 17.326q-.256-.002-.51-.021V18.814q.252-.017.51-.018c3.756 0 6.801 2.754 6.801 6.511s-3.044 6.583-6.801 6.583m12.462 13.575v.218a6.297 6.297 0 0 1-6.295 6.296H7.59a6.296 6.296 0 0 1-6.295-6.296v-.218z\"/>",
  "width": 64,
  "height": 64,
  "viewBox": "0 0 64 64"
}

export default iCoffeeShop
